import { setGTagUser } from "@/plugins/gTag.js";

export default vm => {
  const { rollbar, $user: { sub, ...rest } = {} } = vm;

  rollbar?.configure({ payload: { person: { id: sub, ...rest } } });
  setGTagUser(vm);
};
